import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

interface PrefixOverrideWarningModalProps {
  opened: boolean;
  selectedPrefix: string | null;
  computedPrefix: string | null;
  isSaving: boolean;
  confirmLabel: string;
  onClose: () => void;
  onProceedWithOverride: () => void;
  onReviewPrefix: () => void;
}

export default function PrefixOverrideWarningModal({
  opened,
  selectedPrefix,
  computedPrefix,
  isSaving,
  confirmLabel,
  onClose,
  onProceedWithOverride,
  onReviewPrefix,
}: PrefixOverrideWarningModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Confirm prefix override"
      centered
      withinPortal
      size="sm"
    >
      <Stack gap="md">
        <Alert
          icon={<IconAlertTriangle size={16} />}
          color="yellow"
          variant="light"
          role="alert"
        >
          The selected Assigned Prefix differs from the computed prefix for this
          case. Confirm before saving with the override.
        </Alert>

        <Stack gap={4}>
          <Text size="sm">
            Computed prefix:{" "}
            <Text span fw={700}>
              {computedPrefix}
            </Text>
          </Text>
          <Text size="sm">
            Selected prefix:{" "}
            <Text span fw={700}>
              {selectedPrefix}
            </Text>
          </Text>
        </Stack>

        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onReviewPrefix}>
            Review prefix
          </Button>
          <Button onClick={onProceedWithOverride} loading={isSaving}>
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
